import { Typewriter } from "react-simple-typewriter";
import React from "react";
import { motion } from "framer-motion";

import { images } from "../../constants";
import { AppWrap } from "../../wrapper";
import "./header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Hey there, I am</p>
              <h1 className="head-text">Kartikey Mishr</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">A Software Engineer at McKinsey & Company</p>
            <p className="p-text">
              experienced in product engineering, systems design & GenAI
            </p>
          </div>
        </div>

        <motion.div
          variant={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="app__header-circles circles-left"
        >
          {[images.redux, images.javascript].map((circle, index) => (
            <div className="circle-cmp app__flex" key={`circle-${index}`}>
              <img src={circle} alt="circle" />
            </div>
          ))}
        </motion.div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-typewriter"
      >
        <h1>
          I am {"  "}
          <span>
            <Typewriter
              words={[
                "a developer",
                "a photographer",
                "an adventurer",
                "an aspiring designer",
              ]}
              loop={20}
              cursor
              cursorStyle="|"
              typeSpeed={75}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </span>
        </h1>
      </motion.div>

      <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles circles-right"
      >
        {[images.react, images.java, images.spring].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
